import axios from "axios"
//const API_URL = 'http://localhost:3005'
const API_URL = 'https://warehouse.mediamarketcommerce.com'

/**
 * Get Request
 * @param path 
 * @param params 
 * @returns 
 */
// eslint-disable-next-line
export const getRequest = async (path: string, params: any) => {
    try {
        const { data } = await axios.get(`${API_URL}${path}`, {
            params: params
        });

        return data;
    // eslint-disable-next-line
    } catch (error: any) {
        console.log(error.response.data.message);
        return error.response.data.message;
    }
}

/**
 * Post Request
 * @param path 
 * @param params 
 * @param payload 
 * @returns 
 */
// eslint-disable-next-line
export const postRequest = async (path: string, params: any, payload: any) => {
    try {
        const { data } = await axios.post(`${API_URL}${path}`, payload, {
            params: params
        });

        return data;
    // eslint-disable-next-line
    } catch (error: any) {
        console.log(error.response.data.message);
        return error.response.data.message;
    }
}

/**
 * Put Request
 * @param path 
 * @param params 
 * @param payload 
 * @returns 
 */
// eslint-disable-next-line
export const putRequest = async (path: string, params: any, payload: any) => {
    try {
        const { data } = await axios.put(`${API_URL}${path}`, payload, {
            params: params
        });

        return data;
    // eslint-disable-next-line
    } catch (error: any) {
        console.log(error.response.data.message);
        return error.response.data.message;
    }
}

/**
 * Delete Request
 * @param path 
 * @param params 
 * @returns 
 */
// eslint-disable-next-line
export const deleteRequest = async (path: string, params: any) => {
    try {
        const { data } = await axios.delete(`${API_URL}${path}`, {
            params: params
        });

        return data;
    // eslint-disable-next-line
    } catch (error: any) {
        console.log(error.response.data.message);
        return error.response.data.message;
    }
}